<div class="fixed right-4 top-4 z-50 flex w-[min(92vw,420px)] flex-col gap-2">
  @for (t of toast.toasts(); track t.id) {
    <div
      class="rounded-md border px-3 py-2 text-sm shadow-lg backdrop-blur-md"
      [class]="
        t.variant === 'success'
          ? 'border-emerald-500/30 bg-emerald-500/10 text-emerald-100'
          : t.variant === 'error'
            ? 'border-red-500/30 bg-red-500/10 text-red-100'
            : 'border-[var(--border-color)] bg-[var(--bg-panel)]/90 text-[var(--text-main)]'
      "
    >
      <div class="flex items-start justify-between gap-3">
        <pre class="m-0 whitespace-pre-wrap break-words font-mono text-[11px] leading-4">{{ t.message }}</pre>
        <button
          type="button"
          class="shrink-0 rounded px-1 text-xs opacity-70 hover:opacity-100"
          (click)="toast.dismiss(t.id)"
          aria-label="Dismiss toast"
        >
          ✕
        </button>
      </div>
    </div>
  }
</div>

